import React, { useEffect, useState } from 'react';

const retroIcons = [
  // iMac G3
  { id: 'imac', svg: (
    <svg viewBox="0 0 40 40" fill="none" className="w-full h-full">
      <rect x="8" y="4" width="24" height="20" rx="3" fill="#2D8B8B" opacity="0.6" stroke="#4DC9C9" strokeWidth="0.5"/>
      <rect x="10" y="6" width="20" height="14" rx="1" fill="#111" stroke="#333" strokeWidth="0.5"/>
      <text x="20" y="14" textAnchor="middle" fill="#00FF41" fontSize="4" fontFamily="monospace">iMac</text>
      <rect x="14" y="26" width="12" height="3" rx="1" fill="#2D8B8B" opacity="0.4"/>
      <rect x="12" y="29" width="16" height="1.5" rx="0.5" fill="#333"/>
    </svg>
  )},
  // Nokia 3310
  { id: 'nokia', svg: (
    <svg viewBox="0 0 30 50" fill="none" className="w-full h-full">
      <rect x="5" y="2" width="20" height="46" rx="4" fill="#3D4A5C" stroke="#555" strokeWidth="0.5"/>
      <rect x="8" y="5" width="14" height="10" rx="1" fill="#9DB87D"/>
      <text x="15" y="11" textAnchor="middle" fill="#3D5C2A" fontSize="3" fontFamily="monospace">NOKIA</text>
      <circle cx="15" cy="20" r="3" fill="#555" stroke="#666" strokeWidth="0.5"/>
      {[0,1,2,3,4,5,6,7,8].map(i => (
        <rect key={i} x={7 + (i%3)*5} y={25 + Math.floor(i/3)*5} width="4" height="3.5" rx="1" fill="#555" stroke="#666" strokeWidth="0.3"/>
      ))}
    </svg>
  )},
  // Windows 95
  { id: 'win95', svg: (
    <svg viewBox="0 0 40 40" fill="none" className="w-full h-full">
      <rect x="2" y="2" width="16" height="16" fill="#FF0000" opacity="0.7" rx="1"/>
      <rect x="22" y="2" width="16" height="16" fill="#00FF00" opacity="0.7" rx="1"/>
      <rect x="2" y="22" width="16" height="16" fill="#0000FF" opacity="0.7" rx="1"/>
      <rect x="22" y="22" width="16" height="16" fill="#FFFF00" opacity="0.7" rx="1"/>
      <text x="20" y="42" textAnchor="middle" fill="#888" fontSize="3" fontFamily="monospace">WIN95</text>
    </svg>
  )},
  // FIFA / EA Sports
  { id: 'fifa', svg: (
    <svg viewBox="0 0 40 40" fill="none" className="w-full h-full">
      <circle cx="20" cy="18" r="14" fill="none" stroke="#00FF41" strokeWidth="0.8" opacity="0.5"/>
      <path d="M14 12 L20 8 L26 12 L26 20 L20 24 L14 20 Z" fill="#111" stroke="#00FF41" strokeWidth="0.5" opacity="0.6"/>
      <text x="20" y="18" textAnchor="middle" fill="#00FF41" fontSize="5" fontFamily="monospace" fontWeight="bold">FIFA</text>
      <text x="20" y="38" textAnchor="middle" fill="#666" fontSize="3" fontFamily="monospace">EA SPORTS</text>
    </svg>
  )},
  // MSN Messenger
  { id: 'msn', svg: (
    <svg viewBox="0 0 40 40" fill="none" className="w-full h-full">
      <circle cx="15" cy="14" r="5" fill="#0078D4" opacity="0.6"/>
      <circle cx="25" cy="14" r="5" fill="#00C853" opacity="0.6"/>
      <rect x="8" y="20" width="24" height="14" rx="7" fill="none" stroke="#0078D4" strokeWidth="0.8" opacity="0.5"/>
      <text x="20" y="29" textAnchor="middle" fill="#0078D4" fontSize="4" fontFamily="monospace">MSN</text>
    </svg>
  )},
  // Atari
  { id: 'atari', svg: (
    <svg viewBox="0 0 40 40" fill="none" className="w-full h-full">
      <path d="M20 5 L20 20" stroke="#FF4500" strokeWidth="2" opacity="0.6"/>
      <path d="M12 15 Q12 35 5 35" stroke="#FF4500" strokeWidth="2" opacity="0.6" fill="none"/>
      <path d="M28 15 Q28 35 35 35" stroke="#FF4500" strokeWidth="2" opacity="0.6" fill="none"/>
      <text x="20" y="40" textAnchor="middle" fill="#FF4500" fontSize="3.5" fontFamily="monospace" opacity="0.6">ATARI</text>
    </svg>
  )},
  // Street Fighter
  { id: 'sf', svg: (
    <svg viewBox="0 0 40 40" fill="none" className="w-full h-full">
      <circle cx="20" cy="20" r="16" fill="none" stroke="#FFD700" strokeWidth="0.8" opacity="0.4"/>
      <text x="20" y="16" textAnchor="middle" fill="#FFD700" fontSize="5" fontFamily="monospace" fontWeight="bold" opacity="0.6">SF</text>
      <text x="20" y="24" textAnchor="middle" fill="#FF4444" fontSize="3" fontFamily="monospace" opacity="0.5">FIGHT!</text>
      <path d="M8 30 L14 28 L20 32 L26 28 L32 30" fill="none" stroke="#FFD700" strokeWidth="0.5" opacity="0.4"/>
    </svg>
  )},
  // Gamepad / Pro Evolution
  { id: 'pes', svg: (
    <svg viewBox="0 0 50 30" fill="none" className="w-full h-full">
      <rect x="5" y="5" width="40" height="20" rx="10" fill="#222" stroke="#444" strokeWidth="0.5"/>
      <circle cx="16" cy="15" r="4" fill="none" stroke="#555" strokeWidth="0.5"/>
      <line x1="16" y1="11" x2="16" y2="19" stroke="#555" strokeWidth="0.5"/>
      <line x1="12" y1="15" x2="20" y2="15" stroke="#555" strokeWidth="0.5"/>
      <circle cx="32" cy="12" r="1.5" fill="#00FF41" opacity="0.6"/>
      <circle cx="36" cy="15" r="1.5" fill="#FF4444" opacity="0.6"/>
      <circle cx="28" cy="15" r="1.5" fill="#4444FF" opacity="0.6"/>
      <circle cx="32" cy="18" r="1.5" fill="#FFD700" opacity="0.6"/>
      <text x="25" y="28" textAnchor="middle" fill="#555" fontSize="2.5" fontFamily="monospace">GAMEPAD</text>
    </svg>
  )},
  // Floppy Disk
  { id: 'floppy', svg: (
    <svg viewBox="0 0 40 40" fill="none" className="w-full h-full">
      <rect x="4" y="4" width="32" height="32" rx="2" fill="#222" stroke="#444" strokeWidth="0.5"/>
      <rect x="10" y="4" width="20" height="12" fill="#333" stroke="#555" strokeWidth="0.3"/>
      <rect x="14" y="6" width="12" height="8" fill="#111"/>
      <rect x="12" y="22" width="16" height="14" rx="1" fill="#555" opacity="0.3"/>
      <line x1="14" y1="26" x2="26" y2="26" stroke="#666" strokeWidth="0.3"/>
      <line x1="14" y1="29" x2="26" y2="29" stroke="#666" strokeWidth="0.3"/>
      <line x1="14" y1="32" x2="22" y2="32" stroke="#666" strokeWidth="0.3"/>
    </svg>
  )},
];

const RetroNostalgia = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const generated = retroIcons.map((icon, i) => ({
      ...icon,
      x: 5 + Math.random() * 85,
      y: 10 + (i * 11) + Math.random() * 5,
      size: 28 + Math.random() * 20,
      delay: Math.random() * 15,
      duration: 20 + Math.random() * 20,
      side: i % 2 === 0 ? 'left' : 'right',
    }));
    setItems(generated);
  }, []);

  return (
    <div data-testid="retro-nostalgia" className="fixed inset-0 pointer-events-none z-[1] overflow-hidden">
      {items.map((item) => (
        <div
          key={item.id}
          className="absolute opacity-[0.04] hover:opacity-[0.12] transition-opacity duration-1000"
          style={{
            [item.side]: `${item.side === 'left' ? 2 + Math.random() * 6 : 2 + Math.random() * 6}%`,
            top: `${item.y}%`,
            width: `${item.size}px`,
            height: `${item.size}px`,
            animation: `retroFloat ${item.duration}s ease-in-out ${item.delay}s infinite alternate`,
            filter: 'grayscale(0.5)',
          }}
        >
          {item.svg}
        </div>
      ))}

      <style>{`
        @keyframes retroFloat {
          0% { transform: translateY(0) rotate(0deg); }
          50% { transform: translateY(-15px) rotate(3deg); }
          100% { transform: translateY(5px) rotate(-2deg); }
        }
      `}</style>
    </div>
  );
};

export default RetroNostalgia;
